<template>
    <div class="supportedCards">
        <img v-for="(eachSupportedPayment, index) in supportedPaymentsPerContext" :key="`supported-payment-${index}`" :style="{height: eachSupportedPayment.height}" :src="eachSupportedPayment.asset" :alt="eachSupportedPayment.name">
    </div>
</template>

<script>
import { paymentMethods } from '@/helpers/PaymentHelpers.js';

export default {
    name: 'SupportedCards',
    props: {
        height: {
            default: '50px',
            type: String,
        },
        payments: {
            type: Array,
            default: () => [],
            required: true,
        },
    },
    data() {
        return {
            paymentMethods: paymentMethods,
        };
    },
    computed: {
        supportedPaymentsPerContext() {
            return this.paymentMethods?.filter(paymentMethod =>
                this.payments?.filter(payment => payment.label)
                    .find(validPayment => paymentMethod.name?.toLowerCase().includes(validPayment.label?.toLowerCase())));
        },
    },
};
</script>

<style lang="scss" scoped>
.supportedCards {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        margin: 0 0.25rem;
        width: auto;
    }
}
</style>
